// ink-component
import React from 'react';
import styled from 'styled-components';

import DropdownAura from '../DropdownAura/DropdownAura';

import { dropdownTokens } from '../../../../tokens/components/Dropdown/tokens';

const DropdownSeparatorLine = styled.hr`
  background-color: ${dropdownTokens.ItemSeparatorBackgroundColorBaseDefault};
  border: ${dropdownTokens.ItemSeparatorBorderWidthBaseDefault};
  height: 1px;
  margin: ${dropdownTokens.ItemSeparatorSpacingVerticalBaseDefault} 0;
`;

export interface DropdownSeparatorProps {}

/**
 * @purpose A line separator for Dropdown.Item(s)
 * @categories navigation
 * @group Dropdown
 */

function DropdownSeparator(props: DropdownSeparatorProps) {
  return (
    <DropdownAura>
      <DropdownSeparatorLine />
    </DropdownAura>
  );
}

DropdownSeparator.defaultProps = {};

DropdownSeparator.displayName = 'Dropdown.Separator';

export default DropdownSeparator;
